import { QueryClient } from '@tanstack/react-query'

/**
 * TanStack Query Client Configuration
 * 
 * Optimized defaults for production:
 * - 5 minute stale time
 * - Single retry on failure
 * - No refetch on window focus (better UX for SPAs)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})






